/* eslint-disable padding-line-between-statements */
import { Avatar, Icon } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/legacy/services';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PhoneUtil } from '@xengage/gw-portals-viewmodel-js';
import {
    ViewModelForm,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import cx from 'classnames';
import { ContactService } from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import gatewayMessages from '../../gateway.messages';
import messages from '../Contacts.messages';
import tabStyles from '../Contacts.module.scss';
import metadata from './PolicyContactsPage.metadata.json5';

const PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber',
};

const roleAbstractEntities = [
    'PolicyContactRole',
    'BAPolicyContactRole',
    'BOPPolicyContactRole',
    'CPPolicyContactRole',
    'GLPolicyContactRole',
    'PAPolicyContactRole',
    'IMPolicyContactRole',
    'PolicyNamedInsured',
    'WCPolicyContactRole',
    'WCLaborContact',
    'PlcyNonPriNamedInsured',
    'PolicyNamedInsured',
];

class PolicyContactsPage extends Component {
    static contextType = TranslatorContext;

    state = {
        policyContactRoleVM: {},
        policyContactRole: 'allRoles',
        policyContactRoleOptions: [],
        policyContactTableData: {},
    };

    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func,
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        policyNumber: PropTypes.string.isRequired,
        authHeader: PropTypes.shape({}).isRequired,
    };

    writeValue = value => {
        this.setState({
            policyContactRole: value,
        });
    };

    createVM = () => {
        const { viewModelService } = this.props;
        return viewModelService.create(
            {},
            'pc',
            'edge.capabilities.gateway.contact.dto.roles.policy.PolicyContactRoleDTO'
        );
    };

    componentDidMount = () => {
        const policyContactRoleVM = this.createVM();

        this.setState({ policyContactRoleVM }, () => {
            const policyContactRoleOptions = this.getPolicyContactRoles();
            this.setState({ policyContactRoleOptions });
        });
    };

    getPolicyContactSummaries = paginationParams => {
        const { policyContactRole } = this.state;
        const { policyNumber, authHeader } = this.props;
        const role =
            policyContactRole !== 'allRoles' ? [policyContactRole] : [];

        return ContactService.getPolicyContactSummaries(
            policyNumber,
            authHeader,
            role,
            paginationParams.fromPage,
            paginationParams.pageSize
        ).then(response => {
            this.setState({
                policyContactTableData: response,
            });
            const data = this.getResponseData(response.policyContacts);
            return {
                rows: data,
                numberOfRows: response.maxNumberOfResults,
            };
        });
    };

    getResponseData = policyContacts => {
        if (policyContacts) {
            const contactsInfo = policyContacts.map(contact => {
                return {
                    contact: contact.displayName,
                    role: contact.policyContactRoles,
                    involvedWith: contact.associatedPoliciesCount,
                    active: contact.active,
                };
            });
            return contactsInfo;
        }
        return [];
    };

    getPolicyContactRoles = () => {
        const { policyContactRoleVM } = this.state;
        const translator = this.context;
        const allRolesOption = {
            code: 'allRoles',
            name: messages.allRoles,
        };

        const contactRoles = _.get(
            policyContactRoleVM,
            'subtype.aspects.availableValues',
            []
        );

        const roleOptions = contactRoles
            .filter(option => {
                return !roleAbstractEntities.includes(option.code);
            })
            .map(role => {
                return {
                    code: role.code,
                    name: translator(messages[_.lowerFirst(role.code)]),
                };
            });

        roleOptions.unshift(allRolesOption);
        return roleOptions;
    };

    redirectToContactDetails = index => {
        const { policyNumber, history } = this.props;
        const { policyContactTableData } = this.state;
        const { policyContacts } = policyContactTableData;

        history.push({
            pathname: `/policies/${policyNumber}/contactDetails`,
            state: {
                contact: 'policyContacts',
                accountOrPolicyNumber: policyNumber,
                relatedTo: 'policies',
                contactId: policyContacts[index].accountContactPublicID,
            },
        });
    };
    
    getPhoneNumber = (primaryPhoneNumber) => (
        primaryPhoneNumber && 
            <div><Icon
                    tag="span"
                    icon="mi-phone"
                    className={tabStyles.icons}
                />{primaryPhoneNumber}
            </div>
    );
    
    getEmail = (contact) => (
        contact.emailAddress1 && <div><Icon
                tag="span"
                icon="mi-mail"
                className={tabStyles.icons}
                />{contact.emailAddress1}
        </div>
    );
    

    renderContact = (item, index, { path: property }) => {
        const { policyContactTableData } = this.state;
        if (index < policyContactTableData.policyContacts.length) {
            const contact = policyContactTableData.policyContacts[index];
            
            // DE16825
            // if (!contact.primaryPhoneType) {
            //     return null;
            // }
            const phoneNumber =
                contact[PRIMARY_PHONE_TYPE_MAP[contact?.primaryPhoneType]];
            const localeService =
                ServiceManager.getService('locale-service');
            const phoneUtil = PhoneUtil();
            const primaryPhoneNumber = phoneUtil.prettyPrint(
                phoneNumber,
                localeService.getDefaultCountryCode()
            );

            const contactAvatarClass = cx(tabStyles.gwContactAvatar, {
                [tabStyles.gwActiveContactAvatar]: item.active,
                [tabStyles.gwInactiveContactAvatar]: !item.active,
            });

            return (
                <div className={tabStyles.gwContactsTableWrapper}>
                    <div className={tabStyles.gwContactAvatarContainer}>
                        <Avatar
                            className={contactAvatarClass}
                            username={item.contact}
                            onClick={() => {
                                this.redirectToContactDetails(index);
                            }}
                        />
                    </div>
                    <div className={tabStyles.gwContactNameContainer}>
                        <div className={tabStyles.gwContactName}>
                            {item.contact}
                        </div>
                        {this.getPhoneNumber(primaryPhoneNumber)}
                        {this.getEmail(contact)}
                    </div>
                </div>
            );
        }

        return <div />;
    };

    renderRole = (item, index, { path: property }) => {
        const { policyContactRoleVM } = this.state;
        const translator = this.context;
        const roles = item[property];
        const roleOptions = policyContactRoleVM.subtype.aspects.availableValues;
        const getAllRoles = roles
            .map(data => {
                const matchingRole = roleOptions.find(opt => opt.code === data);
                return matchingRole
                    ? translator(messages[_.lowerFirst(matchingRole.code)])
                    : null;
            })
            .join(', ');

        return <div title={getAllRoles}>{getAllRoles}</div>;
    };

    renderPoliciesInvolved = (item, index, { path: property }) => {
        const policiesCount = item[property];
        const isActive = item.active;

        const policiesInvolved = isActive ? (
            <TranslatorContext.Consumer>
                {translator => {
                    const activePolicies =
                        policiesCount > 1
                            ? translator(messages.activePolicies)
                            : translator(messages.activePolicy);
                    return (
                        <div className={tabStyles.gwInvolvedPoliciesContainer}>
                            <h4 className={tabStyles.gwInvolvedPolicies}>
                                {policiesCount}
                            </h4>
                            {activePolicies}
                        </div>
                    );
                }}
            </TranslatorContext.Consumer>
        ) : (
            <TranslatorContext.Consumer>
                {translator => {
                    return translator(gatewayMessages.inactive);
                }}
            </TranslatorContext.Consumer>
        );

        return <div>{policiesInvolved}</div>;
    };

    loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize: pageSize,
        };

        return this.getPolicyContactSummaries(paginationParams);
    };

    render() {
        const { policyContactRole, policyContactRoleOptions } = this.state;
        const overrideProps = {
            policyContactsRoles: {
                availableValues: policyContactRoleOptions,
                value: policyContactRole,
            },
            policyContactsDataTable: {
                key: policyContactRole,
                onFetchData: this.loadData,
            },
        };

        const resolvers = {
            resolveClassNameMap: tabStyles,
            resolveCallbackMap: {
                renderContact: this.renderContact,
                renderRole: this.renderRole,
                renderPoliciesInvolved: this.renderPoliciesInvolved,
                onRowClick: (data, index) => {
                    this.redirectToContactDetails(index);
                },
            },
        };

        const readValue = (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                policyContactRole,
                id,
                path,
                overrideProps
            );
        };

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                onValueChange={this.writeValue}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }
}

export const PolicyContactsComponent = PolicyContactsPage;
export default withRouter(
    withViewModelService(withAuthenticationContext(PolicyContactsPage))
);
